export default __webpack_public_path__ + "static/media/solanaSVG.a43b6196.svg";